export default [
    {
        name: 'ImportFile',
        path: 'DataImport/ImportFile'
    }
];